<template>
  <span class="brand" :class="[`brand--${size}`]">
    <span class="brand__mark">
      <img :src="defaultLogo" alt="ARENASPORT" class="brand__img" />
      <span class="brand__glow" aria-hidden="true"></span>
    </span>

    <span v-if="showText" class="brand__text">
      <span class="brand__name">
        ARENA<span class="brand__name-accent">SPORT</span>
      </span>
      <span class="brand__sub">Digital</span>
    </span>
  </span>
</template>

<script>
import defaultLogo from '@/assets/brand/logo-arspo.png';

/**
 * Lambang merek Arena Sport Digital.
 * Selalu menampilkan logo dan nama resmi website.
 */
export default {
  name: 'BrandLogo',
  props: {
    size: {
      type: String,
      default: 'md',
      validator: (v) => ['sm', 'md', 'lg'].includes(v),
    },
    showText: { type: Boolean, default: true },
  },
  data() {
    return {
      defaultLogo,
    };
  },
};
</script>

<style scoped>
.brand {
  display: inline-flex;
  align-items: center;
  gap: var(--space-3);
  text-decoration: none;
  line-height: 1;
  max-width: 100%;
}

.brand__mark {
  position: relative;
  display: grid;
  place-items: center;
  flex-shrink: 0;
}

.brand__img {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 500ms var(--ease-out-expo);
}

.brand:hover .brand__img { transform: scale(1.08) rotate(-3deg); }

/* Cahaya lembut di belakang logo, muncul saat disentuh kursor */
.brand__glow {
  position: absolute;
  inset: -30%;
  border-radius: 50%;
  background: radial-gradient(circle, rgb(248 168 8 / 0.4) 0%, transparent 68%);
  opacity: 0;
  transition: opacity 500ms var(--ease-out-quart);
  pointer-events: none;
}

.brand:hover .brand__glow { opacity: 1; }

.brand__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex-shrink: 0;
}

.brand__name {
  font-family: var(--font-display);
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: -0.01em;
  color: var(--text-primary);
  line-height: 1;
  white-space: nowrap;
}

.brand__name-accent {
  display: inline-block;
  background: var(--grad-flame-soft);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin-left: 0.18em;
  padding-right: 3px;
}

.brand__img--custom {
  border-radius: 6px;
  object-fit: cover;
}

.brand__name--custom {
  max-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  font-size: 0.85rem;
}

.brand__sub {
  font-family: var(--font-sans);
  font-weight: 600;
  text-transform: uppercase;
  color: var(--text-muted);
  line-height: 1;
}

/* --- Ukuran --- */
.brand--sm .brand__mark { width: 28px; height: 28px; }
.brand--sm .brand__name { font-size: 0.95rem; }
.brand--sm .brand__sub  { font-size: 0.525rem; letter-spacing: 0.22em; }

.brand--md .brand__mark { width: 40px; height: 40px; }
.brand--md .brand__name { font-size: 1.3rem; }
.brand--md .brand__sub  { font-size: 0.6rem; letter-spacing: 0.28em; }

.brand--lg .brand__mark { width: 56px; height: 56px; }
.brand--lg .brand__name { font-size: 1.75rem; }
.brand--lg .brand__sub  { font-size: 0.72rem; letter-spacing: 0.3em; }

@media (min-width: 1200px) {
  .brand--lg .brand__mark { width: 62px; height: 62px; }
  .brand--lg .brand__name { font-size: 1.95rem; }
}

@media (min-width: 992px) and (max-width: 1120px) {
  .brand--md .brand__mark { width: 34px; height: 34px; }
  .brand--md .brand__name { font-size: 1.15rem; }
  .brand--md .brand__sub  { font-size: 0.55rem; letter-spacing: 0.22em; }
}

@media (max-width: 768px) {
  .brand--lg .brand__mark { width: 44px; height: 44px; }
  .brand--lg .brand__name { font-size: 1.35rem; }
  .brand--lg .brand__sub  { font-size: 0.6rem; letter-spacing: 0.22em; }
}

@media (max-width: 480px) {
  .brand {
    gap: var(--space-2);
  }
  .brand--lg .brand__mark { width: 38px; height: 38px; }
  .brand--lg .brand__name { font-size: 1.2rem; }
  .brand--lg .brand__sub  { font-size: 0.525rem; letter-spacing: 0.2em; }

  .brand--md .brand__mark { width: 32px; height: 32px; }
  .brand--md .brand__name { font-size: 1.05rem; }
  .brand--md .brand__sub  { font-size: 0.525rem; letter-spacing: 0.2em; }
}
</style>
